import React, { useState } from "react";
import "../../iqac.css";
import TopNav from "../../../../../Components/TopNav";
import Navbar from "../../../../../Components/Navbar";
import DropdownNav from "../../../../../Components/DropdownNav";
import Footer from "../../../../../Components/Footer";
import Example from "../../../../../Components/Example";
import ScrollToTop from "react-scroll-to-top";

const Objectives = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [framework, setFramework] = useState(false);

  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className="navbar-area">
        <div className="obj-image">
          <div className="image-cover"></div>
        </div>
      </div>

      {/* This iqac details part */}

      <div className="iqac-details">
        <div className="iqac-header">
          <h1>Internal Quality Assurance Cell - (IQAC)</h1>
          <h1 className="iqac-obj-tit">Objectives</h1>
        </div>
      </div>

      {/* This is the body part of the iqac Objectives */}

      <div className="iqac-obj-det">
        <button
          onClick={() => setIsOpen((e) => !e)}
          style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          Objective of the IQAC
        </button>
        {isOpen && (
          <div className="obj-items">
            <p>
              ✬ To develop a system for conscious, consistent and catalytic
              action to improve the academic and administrative performance of
              the institution.
            </p>
            <p>
              ✬ To promote measures for institutional functioning towards
              quality enhancement through internalization of quality culture and
              institutionalization of best practices.
            </p>
            <p>
              ✬ To ensure the education offered here to be effective and
              efficient with high standard
            </p>
            <p>
              ✬ To provide a sound basis for decision making imbibing all the
              dimensions of service quality to improve institutional
              functioning.
            </p>
            <p>
              ✬ To coordinate and improve internal communication to facilitate
              greater policy implementation and quality assurance towards its
              stakeholders.
            </p>
          </div>
        )}

        <button
          onClick={() => setFramework((e) => !e)}
          style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          Framework of Quality Assessment of (HEI)
        </button>
        {framework && (
          <div className="obj-items">
            <p>✬ Contributing to National Development</p>
            <p>✬ Fostering Global Competencies among Students</p>
            <p>✬ Inculcating a Value System among Students</p>
            <p>✬ Promoting the Use of Technology</p>
            <p>✬ Quest for Excellence</p>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Objectives;
